exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);

// exports
